
export class Document {

    id: string;
    file_name: string;
    name: string;
    mime_type: string;
    icon_class: string;
    file_size: string;
    content: string;
    date_commit: string;
    agence_bureaux_id: string;
    title: string;
    url: string;
    path: string;
    published: string;
    web_url: string;
    extranet: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.id                 = data['id'] ? data['id'] : null;
        this.file_name          = data['file_name'] ? data['file_name'] : null;
        this.name               = data['name'] ? data['name'] : null;
        this.mime_type          = data['mime_type'] ? data['mime_type'] : null;
        this.icon_class         = data['icon_class'] ? data['icon_class'] : null;
        this.file_size          = data['file_size'] ? data['file_size'] : null;
        this.content            = data['content'] ? data['content'] : null;
        this.date_commit        = data['date_commit'] ? data['date_commit'] : null;
        this.agence_bureaux_id  = data['agence_bureaux_id'] ? data['agence_bureaux_id'] : null;
        this.title              = data['title'] ? data['title'] : null;
        this.url                = data['url'] ? data['url'] : null;
        this.path               = data['path'] ? data['path'] : null;
        this.published          = data['published'] ? data['published'] : null;
        this.web_url            = data['web_url'] ? data['web_url'] : null;
        this.extranet           = data['extranet'] ? data['extranet'] : null;
    }

    isPdf() {
        let isPdf = false;
        switch (this.mime_type) {
            case 'application/pdf':
                isPdf = true;
                break;
            default:
                isPdf = false;
                break;
        }

        return isPdf;
    }

    isImage() {
        let isImg = false;
        switch (this.mime_type) {
            case 'image/jpeg':
            case 'image/png':
            case 'application/octet-stream':
                isImg = true;
                break;
            default:
                isImg = false;
                break;
        }

        return isImg;
    }

}
